import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ReaderFooter } from '../components/ReaderFooter';
import { ReaderNavbar } from '../components/ReaderNavbar';
import { StoryRow } from '../components/StoryRow';
import { TldrSubscribeBand } from '../components/TldrSubscribeBand';
import { useUser } from '../providers/UserProvider';
import * as storyRepository from '../repositories/storyRepository';
import type { StoryElement } from '../types';
import { TLDR_CHANNEL_ID } from '../utils/channelUrl';

export default function StoryPermalinkPage() {
  const { identifier } = useParams<{ identifier: string }>();
  const navigate = useNavigate();
  const { user, logout, isAdmin } = useUser();
  const [story, setStory] = useState<StoryElement | null>(null);
  const [expanded, setExpanded] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!identifier) return;
    setStory(null);
    setError('');
    storyRepository.getStoryPermalink(identifier)
      .then((result) => {
        setStory(result.story);
        if (result.permalink_id !== identifier) {
          navigate(`/story/${encodeURIComponent(result.permalink_id)}`, { replace: true });
        }
      })
      .catch((reason) => setError((reason as Error).message || 'Story not found'));
  }, [identifier, navigate]);

  return (
    <div className="reader-shell story-permalink-page">
      <ReaderNavbar
        selectedChannelId={TLDR_CHANNEL_ID}
        onSelectChannel={() => undefined}
        user={user}
        onLogout={logout}
      />
      <TldrSubscribeBand />
      <main className="reader-main-full">
        <section className="feed-list-pane">
          <div className="feed-list">
            {!story && !error && <div className="empty-panel">Loading story…</div>}
            {error && <div className="empty-panel">{error}</div>}
            {story && (
              <StoryRow
                story={story}
                isAdmin={isAdmin}
                isExpanded={expanded}
                onFocusStory={() => undefined}
                onToggleExpanded={() => setExpanded((value) => !value)}
                eventContext={{ surface: 'article', surfaceId: identifier }}
              />
            )}
          </div>
        </section>
      </main>
      <ReaderFooter />
    </div>
  );
}
